export enum LipoRouteEnum {
  HOME = '',
  PARTNER = 'partner',
  CUSTOMER = 'customer',
  SYSTEM = 'system',
  LICENCE = 'license',
  ADMIN = 'admin',
  PRODUCT = 'product',
  PRODUCT_PRICE = 'price',
  PROXY = 'proxy',
  TENANT = 'tenant',
  USER = 'user',
  TOKEN = 'token',
  USER_MAPPING = 'user-mapping',
  WIZARD = 'wizard',
  AUTH = 'auth',
  REALM_CHOOSER = 'realm',
  NOT_ALLOWED = 'not-allowed',
}
